function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M95.0714 24H105.884C109.328 24 110.764 28.4041 107.982 30.4343C105.886 31.9638 104.502 34.2797 104.147 36.85L103.796 39.3974C103.221 43.5651 100.003 46.8747 95.8534 47.5664L76.1311 50.8534C74.5548 51.1161 72.9523 50.567 71.8684 49.3928C69.1678 46.4672 65.0704 45.2755 61.222 46.2965L48.3404 49.7141C44.2341 50.8035 39.905 50.7229 35.842 49.4815L29.9833 47.6913C25.9201 46.4498 21.521 46.9889 17.8777 49.1748C11.5374 52.979 3.56779 47.9443 4.28001 40.5847L4.7243 35.9937C4.93347 33.8324 4.7346 31.6509 4.13805 29.563L3.93679 28.8586C1.61392 20.7285 6.37462 12.2661 14.529 10.0302L20.2971 8.44863C24.0852 7.40996 28.1415 8.2414 31.2155 10.6866L35.5344 14.1221C42.9037 19.984 53.8356 17.1511 57.4304 8.44788C59.0264 4.58399 63.2855 2.55248 67.2927 3.74381L71.1576 4.89286C73.7736 5.67057 76.0671 7.27502 77.6945 9.46579L84.5676 18.7179C87.0362 22.041 90.9317 24 95.0714 24Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgDesert3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 54,
    viewBox: "0 0 113 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesert3);
export default __webpack_public_path__ + "static/media/desert3.49ff1bf0.svg";
export { ForwardRef as ReactComponent };